import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Image } from '../../uiComponents/layout/Image';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Row, Col, Form } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { PasswordFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationResult, ValidationError } from '../../infrastructure/ValidationResult';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { EksternBrugerPasswordResetPublicModel } from '../../models/EksternBrugerPasswordResetPublicModel';
import { EksternBrugerPasswordResetTokenPublicModel } from '../../models/EksternBrugerPasswordResetTokenPublicModel';
import NotificationModule from '../../uiComponents/layout/Notification';
import { Loading } from '../../uiComponents/Loading';

interface EksternAdgangNulstilProps extends RouteComponentProps<any> {
    
}

interface EksternAdgangNulstilState {
    nulstilPayload: EksternBrugerPasswordResetPublicModel;
    nulstilModel: EksternBrugerPasswordResetTokenPublicModel;
    isSubmitting: boolean;
    validationResult: ValidationResult;
    nulstillet: boolean;
}

class EksternAdgangNulstil extends React.Component<EksternAdgangNulstilProps, EksternAdgangNulstilState> {
    constructor(props: EksternAdgangNulstilProps) {
        super(props);

        const nulstilPayload = new EksternBrugerPasswordResetPublicModel();
        nulstilPayload.passwordResetTokenPublicId = '';
        nulstilPayload.password = '';
        nulstilPayload.passwordConfirmed = '';

        const nulstilModel = new EksternBrugerPasswordResetTokenPublicModel();
        nulstilModel.resetTokenPublicId = '';
        nulstilModel.resetLinkErForældet = false;
        nulstilModel.resetLinkErBrugt = false;

        this.state = { nulstilPayload: nulstilPayload, nulstilModel: nulstilModel, isSubmitting: false, nulstillet: false, validationResult: new ValidationResult() };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        const nulstillingsId = this.props.match.params.id;
        const self = this;
        createApiCaller().getNulstilEksternBruger(nulstillingsId).then(response => {
            const nulstilPayload = self.state.nulstilPayload;
            nulstilPayload.passwordResetTokenPublicId = response.resetTokenPublicId;

            self.setState({ nulstilModel: response, nulstilPayload: nulstilPayload });
        });
    }

    onChange(fieldName: string, value: any) {
        const nulstilPayload = this.state.nulstilPayload;
        nulstilPayload[fieldName] = value;
        const newValidationResult = this.state.validationResult;
        newValidationResult.errorMessages = [];

        this.setState({ nulstilPayload: nulstilPayload, validationResult: newValidationResult });
    }

    onSubmit() {
        const { password, passwordConfirmed } = this.state.nulstilPayload;

        if (!this.validateForm(password, passwordConfirmed)) {
            return;
        }

        const self = this;
        self.setState({ isSubmitting: true });
        createApiCaller().nulstilEksternBruger(this.state.nulstilPayload).then(response => {
            NotificationModule.showSuccess('', 'Din adgangskode er nulstillet og du kan nu logge ind med din nye kode.');
            self.setState({ nulstillet: true, isSubmitting: false });
        });
    }

    validateForm(password: string, confirmPassword: string): boolean {
        let isValid = true;
        if (password === '') {
            const validationError = new ValidationError('password', 'Adgangskode skal udfyldes');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        } else if (confirmPassword === '') {
            const validationError = new ValidationError('passwordConfirmed', 'Bekræft adgangskode skal udfyldes');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        } else if (password !== confirmPassword) {
            const validationError = new ValidationError('password', 'De to adgangskoder skal være ens');
            const newValidationResult = this.state.validationResult;
            newValidationResult.errorMessages.push(validationError);

            this.setState({ validationResult: newValidationResult });
            isValid = false;
        }

        return isValid;
    }

    getNulstilAdgangskodeText() {
        return (
            <div>
                <p>Du har efterspurgt en nulstilling af dit password.</p>
                <p>For at nulstille dit password skal du indtaste et nyt password herunder.</p>
                <br />
            </div>
        );
    }

    getNulstilAdgangskodeContent() {
        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup>
                        <Section>
                            <Loading isLoading={this.state.nulstilPayload.passwordResetTokenPublicId === ''}>
                                <Form onSubmit={this.onSubmit}>
                                    <div id='aktiver-profil-page'>
                                        <Row>
                                            <Col md={2} mdOffset={2} className='image'>
                                                <Image source='login-person.png' />
                                            </Col>
                                            <Col md={6}>
                                                <h1>Nulstil adgangskode</h1>
                                                {this.getNulstilAdgangskodeText()}
                                                <PasswordFormGroup 
                                                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                    label='Password*'
                                                    name='password'
                                                    placeholder='Indtast adgangskode'
                                                    value={this.state.nulstilPayload.password}
                                                    onChange={this.onChange}
                                                />
                                                <PasswordFormGroup 
                                                    errorMessages={this.state.validationResult === undefined ? [] : this.state.validationResult.errorMessages}
                                                    label='Bekræft adgangskode*'
                                                    name='passwordConfirmed'
                                                    placeholder='Indtast password igen'
                                                    value={this.state.nulstilPayload.passwordConfirmed}
                                                    onChange={this.onChange}
                                                />
                                                <SubmitButton isSubmitting={this.state.isSubmitting}>{this.state.isSubmitting ? 'Vent...' : 'Nulstil'}</SubmitButton>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form> 
                            </Loading>
                        </Section>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }

    getUdloebetLinkContent(forældet: boolean, alleredeAktiveret: boolean) {
        const header = forældet ? 'Nulstillingslink er udløbet' : 'Dette nulstillingslink er ikke længere gyldigt';
        const content = forældet ? 'Dette nulstillingslink er udløbet og er derfor ikke længere gyldigt. For at få tilsendt et nyt nulstillingslink skal du udfylde formularen til glemt adgangskode igen.'
                                : 'Dette nulstillingslink er allerede brugt og er derfor ikke længere gyldigt.';

        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup>
                        <Section>
                            <Row>
                                <Col md={2} mdOffset={2} className='image'>
                                    <Image source='login-person.png' />
                                </Col>
                                <Col md={6}>
                                    <h1>{header}</h1>
                                    <div>
                                        <p>{content}</p>
                                        <br />
                                    </div>
                                </Col>
                            </Row>
                        </Section>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }

    render() {
        const { nulstillet } = this.state;
        const { resetLinkErForældet, resetLinkErBrugt } = this.state.nulstilModel;

        if (nulstillet) {
            return <Redirect to='/emaillogin' />;
        }

        if (resetLinkErForældet || resetLinkErBrugt) {
            return this.getUdloebetLinkContent(resetLinkErForældet, resetLinkErBrugt);
        }

        return this.getNulstilAdgangskodeContent();
    }
}

export default EksternAdgangNulstil;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/eksternAdgang/EksternAdgangNulstil.tsx